<script setup>
import { cdnImageUrl } from '@dpgradio/creative'
import { watch } from 'vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const data = ref({
  imageUrl: null,
  position: null,
})

const circle = ref(null)
const timeline = ref(null)

const setData = (newItem) => {
  const currentImage = newItem.enrichment.track.thumbnail || newItem.enrichment.track.artist.photo
  const edition = newItem.enrichment.track.activeEditions?.[0]

  data.value.imageUrl = cdnImageUrl(currentImage)
  data.value.position = edition?.position ? `#${edition.position}` : null
}

const doAppear = async () => {
  timeline.value = gsapTimeline({ name: 'NowPlaying' }).fromTo(circle.value, { scale: 15 }, { scale: 0, duration: 0.4 }, '<')
  return timeline.value
}

const doDisappear = async () => {
  if (timeline.value) {
    timeline.value.kill()
  }
  return timeline.value?.reversed(true)
}

const { onDisappear } = useDisappearable()
onDisappear(async () => doDisappear())

onMounted(() => {
  setData(item)
  doAppear()
})

watch(
  () => item,
  async (newItem) => {
    await doDisappear()

    setData(newItem)

    await new Promise((resolve) => setTimeout(resolve, 500)) // Small delay, otherwise the animation is too quick

    await doAppear()
  }
)
</script>

<template>
  <div class="size-full">
    <div ref="circle" class="bg-joe-cr-rose-primary w-64 h-64 rounded-full absolute z-10 left-1/2 top-1/2 -mt-32 -ml-32 scale-[15]" />

    <div class="size-full flex items-center justify-between pl-32 pr-80">
      <div v-if="data.imageUrl" ref="maskElement" class="size-[60rem] mr-24 rounded-3xl relative">
        <div class="overflow-hidden">
          <img ref="imageElement" :src="data.imageUrl" class="w-full h-full object-cover scale-105" />
        </div>
        <div v-if="data.position" class="absolute -bottom-24 left-0 right-0 flex justify-center">
          <div class="rounded-full bg-joe-cr-rose-primary text-white px-20 font-geomanist text-[8rem] font-bold tracking-tight mt-80">{{ data.position }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
